import { Box, makeStyles } from "@material-ui/core";
import Loading from "components/Loading/Loading";

const useStyles = makeStyles(() => ({
	root: {
		height: '100vh',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		background:"white"
	},

}));

const SplashScreen = () => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>
			<Loading />
		</Box>
	);
};

export default SplashScreen;
